export default __webpack_public_path__ + "d9257eb40f17f9e70a0603767c2ae33b.png";